export const DEFAULT_CREATE_AGENT_PROMPT_EN =
  'I want to create an agent, show input fields for agent name and description plus a visibility selector (Only Me or My Organization), then create the agent using the submitted values and apply the selected visibility setting.';

export const DEFAULT_CREATE_AGENT_PROMPT_DE =
  'Ich möchte einen Agenten anlegen, Eingabefelder für den Namen und die Beschreibung des Agenten sowie eine Auswahl für die Sichtbarkeit („Nur ich“ oder „Meine Organisation“) anzeigen, anschließend den Agenten anhand der eingegebenen Werte anlegen und die ausgewählten Sichtbarkeitseinstellungen anwenden.';

export function defaultCreateAgentChatPrompt(language?: string) {
  return (language || '').toLowerCase().startsWith('de')
    ? DEFAULT_CREATE_AGENT_PROMPT_DE
    : DEFAULT_CREATE_AGENT_PROMPT_EN;
}

export function createAgentChatNavigation({
  language,
  translatedPrompt,
}: {
  language?: string;
  translatedPrompt?: string;
}) {
  const fallbackPrompt = defaultCreateAgentChatPrompt(language);
  const prompt = translatedPrompt?.trim() ? translatedPrompt : fallbackPrompt;

  return {
    to: '/chat?createAgent=true',
    state: {
      agentDraft: prompt,
      prompt,
    },
  };
}
